import { EreportsShowFields } from '../fields';
import { Show } from 'react-admin';

export const EreportShow = () => (
    <Show>
        <EreportsShowFields />
    </Show>
);

